export enum ConfigurationCriteriaEnum {
  ForecastNotValidatedSince = 'forecast-not-validated-since',
  SalesDeviationForecast = 'sales-deviation-forecast',
  SmapeLastMonths = 'smape-last-months',
  FirstStockingLastMonths = 'first-stocking-last-months',
  // Bestsellers = 'bestsellers',
  // Top = 'top',
  TrackingSignal = 'tracking-signal',
  DestockingLastDays = 'destocking-last-days',
}
